import { coreAdvantages } from '@/mocks/clsqData';

export default function CoreAdvantagesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-primary-100/70 text-primary-700 rounded-full text-xs font-medium mb-4">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            clsq核心优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            六大核心竞争力，为您提供全方位的品质保障与专业服务
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {coreAdvantages.map((item) => (
            <div
              key={item.id}
              className="group p-6 md:p-8 bg-background-100 rounded-lg border border-background-200/60 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100/80 text-accent-600 mb-5 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}